import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Column, LineClamp } from '~/commonComponents';
import { IColumnDef } from '~/commonComponents/DataGrid';
import { InviteProfessional } from '~/commonComponents/InviteProfessional';
import { IDashboardJob } from '~/domain/DashboardJobs';
import { UserSubProfession } from '~/enums/UserProfession';
import { ArrowRightIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

type TDataGridCommonColumn = {
  Action: IColumnDef<IDashboardJob>;
  Details: IColumnDef<IDashboardJob>;
  Invite: IColumnDef<IDashboardJob>;
  Office: IColumnDef<IDashboardJob>;
  Profession: IColumnDef<IDashboardJob>;
  Rate: IColumnDef<IDashboardJob>;
  Type: IColumnDef<IDashboardJob>;
};

export const DataGridCommonColumn: TDataGridCommonColumn = {
  Action: {
    key: 'action',
    header: '',
    width: '50px',
    align: 'center',
    render: () => <ArrowRightIcon />,
  },
  Details: {
    key: 'details',
    header: 'Details',
    width: '192px',
    render: (item) => (
      <Column gap={4}>
        <Typography as="span" bold>{item.date}</Typography>
        <Typography as="span" color={colors.neutral[500]}>
          {item.startTime} - {item.endTime}
        </Typography>
      </Column>
    ),
  },
  Invite: {
    key: 'invite',
    header: 'Invite',
    width: '80px',
    align: 'center',
    render: (item) => {
      if (item.dashboardJobApi.isOnsiteInterview) {
        return null;
      }

      return <InviteProfessional shift={item.dashboardJobApi} size="icon" />;
    },
  },
  Office: {
    key: 'office',
    header: 'Office',
    width: '1fr',
    render: (item) => (
      <LineClamp lineClamp={2} text={item.office.name} style={{ color: colors.neutral[600] }} />
    ),
  },
  Profession: {
    key: 'profession',
    header: 'Profession',
    width: '192px',
    render: (item) => (
      <Column gap={4}>
        <Typography as="span" bold>
          {UserSubProfession.getName(item.subProfession ?? '') ?? item.professionName}
        </Typography>
        <Typography as="span" color={colors.neutral[500]}>{item.specialty?.split('_')?.[1] ?? 'General'}</Typography>
      </Column>
    ),
  },
  Rate: {
    key: 'rate',
    header: (
      <Typography as="span" bold color={colors.primary[500]} size="body_large" style={{ paddingLeft: 24 }}>
        Rate
      </Typography>
    ),
    width: '100px',
    render: (item) => (
      <Typography as="span" bold style={{ paddingLeft: 24 }}>
        ${item.rate.toFixed(2)}
      </Typography>
    ),
  },
  Type: {
    key: 'type',
    header: (
      <Typography as="span" bold color={colors.primary[500]} size="body_large" style={{ paddingLeft: 16 }}>
        Type
      </Typography>
    ),
    width: '120px',
    render: (item) => (
      <Box
        alignSelf="flex-start"
        paddingVertical={2}
        paddingHorizontal={10}
        borderRadius={8}
        backgroundColor={
          item.dashboardJobApi.isOnsiteInterview
            ? Colors.jobs_interview_background
            : Colors.jobs_shift_background
        }
      >
        <Typography as="span" color={colors.neutral[500]}>
          {item.dashboardJobApi.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}
        </Typography>
      </Box>
    ),
  },
};
